/** @module Apparel/SKUSourcesMatrix */
define([
    "dojo/_base/declare",
    "csi",
    "csi/_base/underscore",
    "csi/table/matrix/Path"
], function(declare,csi,_,PathMatrix) {

    return declare(PathMatrix, {
        /**
         * @override
         *
         * C8-16071: If a data package has a ProductSource then SKU Source matrix on the SKU needs to be filtered by supplier.
         */
        _filterNodes: function(ctx, spec, nodes) {
            if (!ctx.view.viewParent) {
                return this.inherited(arguments);
            }

            var viewNode = ctx.view.viewParent.getViewNode();
            if (!viewNode || viewNode.$Type != "DataPackage" || !viewNode.ForProductSource || viewNode.ForProductSource == csi.EMPTY_URL) {
                return this.inherited(arguments);
            }

            return _.filter(nodes, function(node) {
                return node.__Parent__ == viewNode.ForProductSource;
            });

        }
    });
});